import { useEffect } from "react";

const TERMS_OF_SERVICE_URL = "https://klink-it.com/terms-of-service/";

export default function TermsOfService() {
  useEffect(() => {
    window.location.replace(TERMS_OF_SERVICE_URL);
  }, []);

  return null;
}
